import Vue from 'vue'

import { apiGet } from '../api'

export default {
  namespaced: true,
  state: {
    // {
    //   bitrix24: { code: 'bitrix24', ... },
    // }
    map: null,
    // {
    //   bitrix24: { healthCheck: 'Успешно!', isOk: true },
    //   amocrm: { healthCheck: 'Ошибка синхронизации', isOk: false },
    // }
    healthChecks: {},
  },
  mutations: {
    setMap: (state, { integrations }) => {
      state.map = integrations
    },
    setHealthCheck: (
      { healthChecks },
      { code, healthCheck: { healthCheck, isOk } }
    ) => {
      Vue.set(healthChecks, code, { healthCheck, isOk })
    },
    setHealthChecks: (state, { healthChecks }) => {
      state.healthChecks = healthChecks
    },
  },
  actions: {
    get: ({ rootState, dispatch, commit }) =>
      apiGet({
        rootState,
        dispatch,
        url: '/api/connector/get/',
      })
        .then(({ res: integrations }) => commit('setMap', { integrations })),
    healthCheck: ({ rootState, dispatch, commit }, { code }) =>
      apiGet({
        rootState,
        dispatch,
        url: `/api/connector/health-check/?code=${code}`,
      })
        .then(({ res: healthCheck }) =>
          commit('setHealthCheck', { code, healthCheck }))
        .catch(e => {
          commit('setHealthCheck', {
            code,
            healthCheck: { healthCheck: 'Ошибка проверки', isOk: false },
          })
          throw e
        }),
  },
}
